import { Button, MenuItem, Select, Stack, styled, Typography } from "@mui/material";
import * as React from "react";
import PosterImagePack from "../../Misc/PosterImagePack";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { thumbnailService } from "../../../Core/Api/services";
import { ThumbnailSize } from "../../../Core/Api/Thumbnail/thumbnail-api-service";
import {
  FetchLightPackPlaceholders,
  FetchNonOptionalPlaceholder,
  GetFetchedPacks,
  GetSelectedPack,
  GetSelectedTitles,
  SelectPackById,
} from "../../../Redux/Reducers/redux-slice-new-request";
import { useAppDispatch, useAppSelector } from "../../../Redux/redux-store";
import { useTranslation } from "react-i18next";

interface NewRequestSubbarProps {
  onEditClick: () => void;
}

const NewRequestSubbar: React.FC<NewRequestSubbarProps> = (props) => {
  const { t } = useTranslation();
  const { onEditClick } = props;

  const dispatch = useAppDispatch();

  const selectedTitles = useAppSelector(GetSelectedTitles);
  const fetchedPacks = useAppSelector(GetFetchedPacks);
  const selectedPack = useAppSelector(GetSelectedPack);

  const handleOnChangePack = React.useCallback((packId: number) => {
    dispatch(SelectPackById(packId));

    if (packId > 0) {
      dispatch(FetchNonOptionalPlaceholder(packId));
      dispatch(FetchLightPackPlaceholders(packId));
    }
  }, []);

  return (
    <Stack width="100%" direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
      <Stack flex={1} direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={2} pt={1.5} pb={1.5}>
          <PosterImagePack
            imgs={selectedTitles.map((title) => ({
              src: thumbnailService.GetObjectPosterUrl(title.id, ThumbnailSize.medium),
            }))}
            posterProps={{
              height: 52,
              width: 40,
              borderRadius: "2px",
            }}
          />
          <Stack mr="auto">
            <Typography variant="subtitle2" fontWeight={600} color="text.primary">
              {t("component:body.titleSelected", {
                count: selectedTitles.length,
              })}
            </Typography>
            <Typography color="text.tier" mt={0.5}>
              {selectedTitles.map((title, index) => {
                if (index === selectedTitles.length - 1) return title.name;
                return `${title.name}, `;
              })}
            </Typography>
          </Stack>
        </Stack>
        <Button color="primary" variant="outlined" startIcon={<EditOutlinedIcon />} onClick={onEditClick}>
          {t("common:editUpperCase")}
        </Button>
      </Stack>
      <StyledDivider>
        <svg width="22" height="82" viewBox="0 0 22 82" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 0.999999L21 41L0.999997 81" />
        </svg>
      </StyledDivider>
      <Select
        id="tutorial-request-pack"
        displayEmpty
        IconComponent={ExpandMoreRoundedIcon}
        value={selectedPack?.id || 0}
        onChange={(event, child) => handleOnChangePack(event.target.value as number)}
        sx={{ width: 300 }}
        MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
      >
        <MenuItem value={0}>{t("common:selectPack")}</MenuItem>
        {fetchedPacks.map((pack) => (
          <MenuItem key={pack.id} value={pack.id}>
            {pack.name}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
};

const StyledDivider = styled("figure")(({ theme }) => ({
  alignSelf: "stretch",
  svg: {
    ...theme.helpers(theme).fullImage,
    width: "auto",
    fill: "none",
    stroke: theme.palette.backgroundAlpha.border,
  },
}));

export default NewRequestSubbar;
